/* RESPONSIBLE TEAM: team-ai-agent-2 */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class StandaloneGuidanceController extends Controller {
  queryParams = ['aiContentSegmentIds'];

  @tracked declare aiContentSegmentIds: string;
}
